import "./TermsPage.css";

const termsSections = [
  {
    title: "1. Acceptance of Terms",
    content:
      "By downloading, installing, or using the App, you agree to be bound by these Terms of Service.\n\nIf you do not agree to these Terms, please do not use the App.",
  },
  {
    title: "2. Description of the Service",
    content:
      "The App is a social party game that allows users to play interactive guessing games in different modes.\n\nThe App is provided for entertainment purposes only.",
  },
  {
    title: "3. License to Use",
    content:
      "You are granted a limited, non-exclusive, non-transferable, and revocable license to use the App for personal, non-commercial purposes.\n\nYou may not copy, modify, distribute, or reverse engineer any part of the App.",
  },
  {
    title: "4. User Responsibilities",
    content:
      "You agree to use the App in compliance with all applicable laws and regulations.\n\nYou must not misuse the App or attempt to interfere with its proper functioning.",
  },
  {
    title: "5. Intellectual Property",
    content:
      "All content, design, code, and functionality of the App are the property of the developer and are protected by applicable copyright laws.\n\nYou may not reproduce or distribute any part of the App without prior written permission.",
  },
  {
    title: "6. Disclaimer of Warranties",
    content:
      'The App is provided "as is" and "as available" without warranties of any kind.\n\nWe do not guarantee that the App will be error-free or uninterrupted.',
  },
  {
    title: "7. Limitation of Liability",
    content:
      "To the fullest extent permitted by law, the developer shall not be liable for any indirect, incidental, or consequential damages arising from the use or inability to use the App.",
  },
  {
    title: "8. Changes to These Terms",
    content:
      "We reserve the right to modify these Terms at any time.\n\nChanges will become effective upon publication on the website.",
  },
  {
    title: "9. Governing Law",
    content:
      "These Terms are governed by the laws of Germany.\n\nAny disputes shall be subject to the jurisdiction of the courts in Germany.",
  },
  {
    title: "10. Contact",
    content:
      "If you have any questions about these Terms, you can contact:\n\nEmail: getit.lhamb@gmail.com\nWebsite: larshamburger.com",
  },
];

function TermsPage() {
  return (
    <section className="terms-page">
      <h1 className="terms-page__title">Terms of Service</h1>
      <p className="terms-page__meta">Last Updated: February 2026</p>
      <p className="terms-page__intro">
        These Terms of Service govern your use of the mobile application “Get
        It? – The Party Game”, provided by Lars Hamburger.
      </p>

      <div className="terms-page__sections">
        {termsSections.map((section) => (
          <article key={section.title} className="terms-page__section">
            <h2 className="terms-page__section-title">{section.title}</h2>
            <div className="terms-page__section-content">
              {section.content.split("\n\n").map((paragraph, index) => (
                <p key={`${section.title}-${index}`}>{paragraph}</p>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default TermsPage;
